<template>
  <div class="popup_add_take_show">
    <div
      v-if="allAddAndTakeData.data && allAddAndTakeData.data.length"
      class="add_take_content"
    >
      <div class="add_take_show_bonus">
        <p class="add_take_bonus_tips">
          因合规需求，低档收益下账户金额足够才能设置领取：
        </p>
        <ul class="add_take_bonus_type">
          <li v-if="allAddAndTakeData.bonus && allAddAndTakeData.bonus.opts">
            <select class="disabled" disabled>
              <option
                v-for="b in allAddAndTakeData.bonus.opts"
                :key="b.value"
                :value="b.value"
              >
                {{ b.description }}
              </option>
            </select>
            <i class="iconfont icon-arrow_down" />
          </li>
          <li v-if="allAddAndTakeData.rate && allAddAndTakeData.rate.opts">
            <select class="disabled" disabled>
              <option
                v-for="b in allAddAndTakeData.rate.opts"
                :key="b.value"
                :value="b.value"
              >
                {{ getBonusDescription(b) }}
              </option>
            </select>
            <i class="iconfont icon-arrow_down" />
          </li>
        </ul>
      </div>
      <table class="add_take_show_table">
        <thead>
          <tr>
            <th>年度</th>
            <th>年龄</th>
            <th v-show="accountPart !== 'take'">
              当年追加
            </th>
            <th v-show="accountPart !== 'add'">
              当年领取
            </th>
            <th>账户价值</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="tr in addAndTakeTable" :key="JSON.stringify(tr)">
            <td>
              <span>{{ tr[0] + allAddAndTakeData.startPolicyNo - 1 }}</span>
            </td>
            <td>
              <span>{{ tr[1] }}</span>
            </td>
            <td
              v-show="accountPart !== 'take'"
              @click="gotoAddAndTakeForm('add', tr)"
            >
              <span :class="{ value_unequal_zero: tr[2] !== 0 }">{{
                tr[2]
              }}</span>
              <i
                v-if="tr[2] !== 0"
                class="iconfont icon-close_circle_surface"
                @click.stop="deleteAccount('add', tr)"
              />
            </td>
            <td
              v-show="accountPart !== 'add'"
              @click="gotoAddAndTakeForm('take', tr)"
            >
              <span :class="{ value_unequal_zero: tr[3] !== 0 }">{{
                tr[3]
              }}</span>
              <i
                v-if="tr[3] !== 0"
                class="iconfont icon-close_circle_surface"
                @click.stop="deleteAccount('take', tr)"
              />
            </td>
            <td>
              <span>{{ Math.round(tr[4]) }}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="warn_tips">
      温馨提示：以上演示说明为本平台对上述产品的理解便于保险从业人员学习、交流，演示数据仅供参考，请以实际为准。
    </div>
  </div>
</template>

<script>
export default {
  name: 'PopupAddAndTakeShow',
  props: {
    age: Number,
    accountData: Object,
    allAddAndTakeData: Object,
    popopBaseConf: Object
  },
  data () {
    return {
      instanceScroll: null,
      accountPart: this.accountData.accountPart
    }
  },
  computed: {
    addAndTakeTable () {
      let tableData = []
      // let accountValues =
      //   this.allAddAndTakeData.data[2] && this.allAddAndTakeData.data[2].values
      const account = this.allAddAndTakeData.data.find(
        item => item.key === 'account_value'
      )
      let accountValues = account.values
      let addAndTakeData = this.initAddAndTakeData()
      if (accountValues && accountValues.length) {
        accountValues.map((val, i) => {
          let year = i + 1
          let addBaof = 0
          let takeBaof = 0
          let purpose = ''
          addAndTakeData.map(ad => {
            if (ad.adjustData && ad.adjustData.length) {
              ad.adjustData.map(j => {
                if (year >= j[0] && year <= j[1]) {
                  if (ad.key === 'add') {
                    addBaof = j[2]
                  } else {
                    takeBaof = j[2]
                  }
                  purpose = j[3] || ''
                }
              })
            }
          })
          tableData.push([
            i + 1, // 年度
            this.age + this.allAddAndTakeData.startIndex + year, // 年龄
            addBaof, // 追加金额
            takeBaof, // 领取金额
            val, // 账户价值
            purpose
          ])
        })
      }
      if (this.allAddAndTakeData.reduceIndex) {
        tableData = tableData.filter(
          e => e[0] > this.allAddAndTakeData.reduceIndex
        )
      }
      return tableData
    }
  },
  created () {
    this.$set(this.accountData, 'addAndTakeData', this.initAddAndTakeData())
  },
  methods: {
    bscroll (instance) {
      instance.options.click = true
      this.instanceScroll = instance
    },
    initAddAndTakeData () {
      let accountData = this.accountData
      let addAndTakeData = []
      if (accountData) {
        if (accountData.addAndTakeData && accountData.addAndTakeData.length) {
          addAndTakeData = accountData.addAndTakeData
        } else {
          switch (accountData.accountPart) {
            case 'addAndTake':
              addAndTakeData.push({ key: 'add', adjustData: [] })
              addAndTakeData.push({ key: 'take', adjustData: [] })
              break
            case 'add':
              addAndTakeData.push({ key: 'add', adjustData: [] })
              break
            case 'take':
              addAndTakeData.push({ key: 'take', adjustData: [] })
              break
          }
        }
      }
      return addAndTakeData
    },
    deleteAccount (type, data) {
      this.popopBaseConf.accountType = type
      this.$emit('deleteAccount', {
        beginYear: data[0],
        endYear: data[0],
        baof: 0,
        purpose: data[5] || ''
      })
    },
    gotoAddAndTakeForm (type, data) {
      this.popopBaseConf.accountType = type
      this.popopBaseConf.formValues = {
        beginYear: data[0],
        endYear: data[0],
        baof: data[type === 'add' ? 2 : 3],
        purpose: data[5]
      }
      this.$emit('openOrClosePopup', 'PopupAddAndTakeForm')
      window.WeiyiStatSDK.submit('jgy_dnzjlq')
    },
    getBonusDescription (opt) {
      let desc = `${opt.description}(${(opt.value * 100).toFixed(2)}%)`
      if (opt.description.search(/\$/) !== -1) {
        desc = `${opt.description.replace('$', '')}`
      }
      return desc
    }
  }
}
</script>

<style lang="postcss" scoped>
.popup_add_take_show {
  padding: 0.2rem;
  background: #f2f2f2;
  color: #333;
  font-size: 0.26rem;
  &:after {
    display: block;
    width: 100%;
    content: '';
    height: 1rem;
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);
    box-sizing: content-box;
  }
  .add_take_content {
    padding: 0.3rem;
    background: #fff;
    border-radius: 0.12rem;
    .add_take_bonus_tips {
      font-size: 0.26rem;
    }
    .add_take_bonus_type {
      display: flex;
      width: 100%;
      padding: 0.3rem 0;
      li {
        position: relative;
        flex: 1;
        padding-right: 0.16rem;
        select {
          width: 100%;
          line-height: normal;
          font-size: 0.28rem;
          height: 0.54rem;
          padding: 0 0.12rem;
          appearance: none;
          min-width: 2.56rem;
          border: 1px solid #e5e5e5;
          border-radius: 0.04rem;
          vertical-align: middle;
          color: #666;
          background: transparent;
          &.disabled {
            color: #ccc !important;
          }
        }
        i {
          position: absolute;
          top: 50%;
          right: 0.3rem;
          transform: translateY(-50%);
          font-size: 0.24rem;
          color: #ccc;
        }
        &:last-child {
          padding-right: 0;
        }
      }
    }
    .add_take_show_table {
      width: 100%;
      color: #333;
      thead {
        font-size: 0.24rem;
        tr {
          th {
            padding: 0.24rem 0.04rem;
            margin-bottom: 0.1rem;
            background: #f8f8f8;
            text-align: center;
            font-weight: normal;
            &:nth-child(1),
            &:nth-child(2) {
              max-width: 0.48rem;
            }
          }
        }
      }
      tbody {
        font-size: 0.28rem;
        color: #666;
        tr {
          td {
            position: relative;
            padding: 0.1rem 0.04rem;
            text-align: center;
            span {
              display: block;
              padding: 0.14rem 0.08rem;
            }
            & .icon-close_circle_surface {
              position: absolute;
              top: 50%;
              transform: translateY(-50%);
              right: 0.12rem;
              color: #ccc;
              font-size: 0.3rem;
            }
            &:nth-child(1),
            &:nth-child(2) {
              width: 0.68rem;
            }
            &:nth-child(3),
            &:nth-child(4) {
              span {
                border: 1px solid #e5e5e5;
                border-radius: 0.12rem;
                color: #ccc;
                &.value_unequal_zero {
                  padding-right: 0.3rem;
                  color: #333;
                }
              }
            }
          }
          &:first-child {
            td {
              padding-top: 0.2rem;
              & .icon-close_circle_surface {
                margin-top: 0.05rem;
              }
            }
          }
        }
      }
    }
  }
  .warn_tips {
    line-height: 145%;
    padding: 0.24rem 0 0.12rem;
    font-size: 0.24rem;
    color: #999;
  }
}
</style>
